<template>
  <div class="side-center-modal side-center-modal-share-slide">
    <div class="font-bold mb-3">
      {{ $i18nPresenter.t('Share as link') }}
    </div>
    <div>
      <div
        class="flex gap-2 items-center p-2 bg-yellow-10 mb-4 rounded"
        v-if="showViewerCannot"
      >
        <span><img alt="giphy-star-icon" :src="require('@/assets/images/icon/warning-circle.svg')"></span>
        {{ $i18nPresenter.t(`You’re a viewer, so you can’t share the slides.`) }}
      </div>
      <div v-else class="side-center_title mb-4">
        {{ $i18nPresenter.t("Anyone with the link can view your slides with audience responses.") }}
      </div>
      <ShareACopy
        :from="'SideCenterShareSlides'"
        :presentation="presentation"
        :hideSentToTeam="true"
        :hideTitle="true"
      />
    </div>
    <div class="divider" />
    <DownloadSlideSection :presentation="presentation" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ShareACopy from '@/components-v2/presentation-editor/collaboration/ShareACopy.vue'
import Utils from '@/util'
import eventCategories from '@/constant/eventCategories'
import constants from '@/constant'
import { ROUTE_NAMES } from '@/constant/routes'
import DownloadSlideSection from '@/components-v2/editor-share-v2/DownloadSlideSection.vue'

export default {
  name: 'SideCenterShareSlides',
  components: { DownloadSlideSection, ShareACopy },
  props: {
    presentation: {
      type: Object,
      default: () => {},
    },
    source: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      role: constants.role,
    }
  },
  computed: {

    ...mapState({
      currentUser: (state) => state.currentUser,
      isEnableAddinPowerpoint: (state) => state.isEnableAddinPowerpoint,
      canViewerShare: (state) => state.canViewerShare,
      isGuestUser: (state) => state.currentUser.isGuest,
      canEditPresentation: (state) => state.canEditPresentation,
    }),

    showViewerCannot() {
      // if (this.presentation.accountId === this.currentUser.accountId) {
      //   return this.currentUser.accountRole === this.role.VIEWER
      // }
      if (this.presentation.permissions === undefined) {
        return false
      }
      return !this.presentation.permissions.includes(constants.permissions.RENAME_PRESENTATION)
    },
  },
  methods: {
    openExport() {
      // if (this.canViewerShare) {
      this.$emit('hideModal')
      Utils.mixpanelTracking(
        !this.source ? eventCategories.PRESENTATION_EDITOR : eventCategories.PRESENTATION_LIST,
        'Share menu > Share slides > Export as',
        null,
        null,
        {
          presentationId: this.presentation.id,
          userId: this.currentUser.id,
          isPresentationOwner: this.presentation.userId === this.currentUser.id,
        },
      )
      this.$router.push({
        name: ROUTE_NAMES.PRESENTATION_REPORT,
        params: {
          id: this.presentation.id,
        },
      })
    },

  },
}
</script>

<style scoped lang="scss">
.divider{
  height: 1px;
  background-color:#EBEBEB;
  margin: 24px 0px;

}
.side-center-modal-share-slide {
  .side-center_title {
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: left;
    margin-bottom: 12px;
  }
}
.badge-option {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px;
  gap: 4px;
  border: 1px solid #EBEBEB;
  border-radius: 4px;
  width: 108px;
  height: 68px;
  color:#282E3E;
}
</style>
